const actions = {
  GET_DATA_ACTIVE: 'GET_DATA_ACTIVE',
  SET_DATA_ACTIVE: 'SET_DATA_ACTIVE',
  EDIT_DATA_ACTIVE: 'EDIT_DATA_ACTIVE',
  DELETE_DATA_ACTIVE: 'DELETE_DATA_ACTIVE',
  SET_NEW_DATA_ACTIVE: 'SET_NEW_DATA_ACTIVE',
  GET_DATA_BEGIN: 'GET_DATA_BEGIN',
  GET_DATA_FINISH: 'GET_DATA_FINISH',
  getActiveData: () => {
    return {
      type: actions.GET_DATA_ACTIVE,
    };
  },
  setActiveData: (data: any) => {
    return {
      type: actions.SET_DATA_ACTIVE,
      data,
    };
  },
  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },
  getDataFinish: () => {
    return {
      type: actions.GET_DATA_FINISH,
    };
  },
  setDeleteActive: (data: any) => {
    return {
      type: actions.DELETE_DATA_ACTIVE,
      data,
    };
  },
  setEditActiveData: (data: any) => {
    return {
      type: actions.EDIT_DATA_ACTIVE,
      data,
    };
  },
  setNewActiveData: (data: any) => {
    return {
      type: actions.SET_NEW_DATA_ACTIVE,
      data,
    };
  },
};

export default actions;
